import * as React from "react";

import { cn } from "~/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type = "text", ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      "flex h-9 w-full rounded-[var(--radius-xs)] border border-border-strong bg-white px-2.5 py-2 text-[14px] leading-[var(--lh-ui)] text-fg-1 placeholder:text-fg-disabled focus-visible:outline-2 focus-visible:outline focus-visible:outline-primary-200 focus-visible:border-primary-500 disabled:cursor-not-allowed disabled:bg-bg-subtle disabled:text-fg-disabled",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";
